import React from 'react';
import WbalTable from '../components/WbalTable';

console.log("LOADED WtBalPage top");

function WtBalPage() {
    console.log("LOADED WtBalPage function");

    return (
        <>
         <article className="App-fuel">
        <WbalTable />
      </article>

    </>
    );
}
export default WtBalPage;
